<script setup lang="ts">
const props = defineProps({
  slice: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  variant: {
    type: String,
    required: false,
    default: 'verticle',
  },
})

const slice = reactive({
  ...props.slice,
  Settings: {
    ...props.slice.Settings,
    Button: {
      Link: props.slice.Settings?.Button?.Link || '',
      Text: props.slice.Settings?.Button?.Text || '',
      Type: props.slice.Settings?.Button?.Type || 'secondary',
      Small: props.slice.Settings?.Button?.Small || false,
    },
  },
})

const getClass = computed(() => {
  return [
    `content-type--${slice?.Settings?.SliceWidth?.toLowerCase()?.replace('_', '-') || 'layout-width'}`,
    {
      'content-type--has-background': slice?.Settings?.BackgroundColor,
      'content-type--fancy-background': !slice?.Settings?.BackgroundColor,
      'content-type--horizontal': props.variant === 'horizontal',
    },
  ]
})

const getStyle = computed(() => {
  return {
    '--slice-bgcolor': slice?.Settings?.BackgroundColor || '#fff',
    '--slice-color': useContrastColor((slice?.Settings?.BackgroundColor || '#fff'), 'var(--color-copy-reverse)', 'var(--color-copy-default)'),
  }
})

const shapes = [{
  content: '🪶',
  x: 0.25,
  y: 0.2,
  size: 40,
  animate: 'move-x',
},
{
  content: '🪶',
  x: 0.50,
  y: 0.5,
  size: 70,
  animate: 'scale',
},
{
  content: '🪶',
  x: 0.50,
  y: 0.5,
  size: 70,
  animate: 'move-y',
},
// {
//   content: '🪄',
//   x: 0.2,
//   y: 0.2,
//   size: 40,
//   animate: 'opacity',
// },
// {
//   content: '🚶🏼‍➡️',
//   x: 0.3,
//   y: 0.2,
//   size: 40,
//   animate: 'scale',
// },
// {
//   content: '🧨',
//   x: 0.0,
//   y: 0.0,
//   size: 40,
//   animate: 'all',
// },
{
  content: '🪽',
  x: 0.34,
  y: 0.45,
  size: 50,
  animate: 'scale',
},
{
  content: '🪽',
  x: 0.75,
  y: 0.2,
  size: 50,
  animate: 'rotate',
},
// {
//   content: '🥢',
//   x: 0.5,
//   y: 0.5,
//   size: 40,
//   animate: 'scale',
// },
// {
//   content: '🛹',
//   x: 0.5,
//   y: 0.5,
//   size: 40,
//   animate: 'scale',
// },
// {
//   content: '🥕',
//   x: 0.5,
//   y: 0.5,
//   size: 40,
//   animate: 'scale',
// },
{
  content: '🥖',
  x: 0.45,
  y: 0.1,
  size: 45,
  animate: 'all',
},
{
  content: '🩹',
  x: 0.5,
  y: 0.2,
  size: 60,
  animate: 'move-y',
},
{
  content: '/',
  x: 0.38,
  y: 0,
  size: 60,
  animate: 'move-x',
},
{
  content: '/',
  x: 0.65,
  y: 0.5,
  size: 80,
  animate: 'all',
},
]
</script>

<template>
  <section
    :id="`slice-${index}`"
    v-bind="$attrs"
    class="content-type"
    :class="getClass"
    :style="getStyle"
  >
    <div
      v-if="!slice?.Settings?.BackgroundColor && shapes?.length"
      class="shapes"
    >
      <span
        v-for="(shape, shapeIndex) in shapes"
        :key="shapeIndex"
        class="shapes__shape"
        :class="{
          [`shapes__shape--${shape.animate}`]: shape.animate !== 'none',
        }"
        :style="`--index: ${shapeIndex}; font-size: ${shape.size}rem; left: ${shape.x * 100}%; top: ${shape.y * 100}%`"
      ><span>{{ shape.content }}</span></span>
    </div>

    <div
      class="content-type__container"
    >
      <div
        v-if="slice?.Settings?.Title || slice?.Settings?.Description"
        class="content-type__header"
      >
        <UiHeading
          v-if="slice?.Settings?.Title"
          class="content-type__heading"
          :force-tag="slice?.Settings?.TitleTag || 'div'"
        >
          {{ slice.Settings.Title }}
        </UiHeading>

        <p
          v-if="slice?.Settings?.Description"
          class="content-type__description"
        >
          {{ slice.Settings.Description }}
        </p>
      </div>

      <div class="content-type__content">
        <UiHeadingSection :disabled="!slice?.Settings?.Title">
          <slot />
        </UiHeadingSection>
      </div>

      <div
        v-if="slice?.Settings?.Button?.Link || slice?.Settings?.Button?.Text"
        class="content-type__footer"
      >
        <StrapiButton
          :button="slice.Settings.Button"
        />
      </div>
    </div>
  </section>
</template>

<style>
@import url("~layers/components/Strapi/Slice.css");
</style>
